import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "../../i18n/LanguageContext";
import StoreButtons from "./StoreButtons";

export const FAQ = () => {
  const { t } = useLanguage();
  const f = t.faq;

  return (
    <section id="faq" className="relative py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="text-xs font-bold uppercase tracking-[0.16em] text-[#7B1113]"
          >
            {f.label}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="mt-4 text-3xl font-medium leading-tight tracking-tight text-[#2A1112] md:text-4xl lg:text-5xl"
            data-testid="faq-heading"
          >
            {f.heading}
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12"
        >
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            className="w-full space-y-4"
            data-testid="faq-accordion"
          >
            {f.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-[#7B1113]/8 bg-white px-6 shadow-[0_16px_36px_-20px_rgba(123,17,19,0.12)] transition-shadow duration-300 hover:shadow-[0_20px_44px_-22px_rgba(123,17,19,0.2)]"
              >
                <AccordionTrigger className="py-5 text-left text-base font-semibold text-[#2A1112] hover:no-underline md:text-lg [&>svg]:text-[#7B1113]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-[#5E4646]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mt-14 flex flex-col items-center gap-6 text-center"
          data-testid="faq-cta"
        >
          <p className="text-lg font-medium text-[#2A1112]">{f.cta}</p>
          <StoreButtons align="center" testidPrefix="faq" />
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
